import React from 'react';
import "./spreadsheetTxt.scss";

//images
import imgspreadsheetTxt from "../../../assets/connectors/spreadsheetTxt.png";
import { useTranslation } from 'react-i18next';


const SpreadsheetTxt = () => {
    const {t} = useTranslation()

    return (
        <div className="container-spreadsheetTxt">
            <div className="img-spreadsheetTxt">
                <img src={imgspreadsheetTxt} alt="" />
            </div>
            <div className="texts-spreadsheetTxt">
                <h1>{t("connectors.spreedsheet.title")}</h1>
                <p> {t("connectors.spreedsheet.section_text_1")}</p>
                <p>{t("connectors.spreedsheet.section_text_2")}</p>
                {/* <button id="btn-spreadsheetTxt">Saiba mais</button> */}
            </div>
        </div>
    )
}

export default SpreadsheetTxt